export default "__VITE_PUBLIC_ASSET__e8ad234c__"